"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useComponentPropsFor = exports.useComponentProps = exports.ComponentPropsProvider = exports.ComponentPropsContext = void 0;
var React = __importStar(require("react"));
var deepmerge_1 = __importDefault(require("deepmerge"));
exports.ComponentPropsContext = React.createContext({});
var ComponentPropsProvider = function (props) {
  var existingProps = React.useContext(exports.ComponentPropsContext) || {};
  var value = props.value,
    children = props.children;
  return React.createElement(exports.ComponentPropsContext.Provider, {
    value: (0, deepmerge_1.default)(existingProps, value)
  }, children);
};
exports.ComponentPropsProvider = ComponentPropsProvider;
var useComponentProps = function () {
  return React.useContext(exports.ComponentPropsContext) || {};
};
exports.useComponentProps = useComponentProps;
function useComponentPropsFor(name, defaultComponentProps, props) {
  var allProps = (0, exports.useComponentProps)();
  var componentContextProps = (allProps === null || allProps === void 0 ? void 0 : allProps[name]) || {};
  return __assign(__assign(__assign({}, defaultComponentProps || {}), componentContextProps), props || {});
}
exports.useComponentPropsFor = useComponentPropsFor;